// src/components/MaturaExamRunner/MaturaExamSnapshotUtils.js

// Zakodowanie ±Infinity, żeby JSON był bezpieczny
export const encodeInf = (val) => {
  if (val === Infinity) return "__+inf__";
  if (val === -Infinity) return "__-inf__";

  if (Array.isArray(val)) return val.map(encodeInf);

  if (val && typeof val === "object") {
    const out = Array.isArray(val) ? [] : {};
    for (const k of Object.keys(val)) {
      out[k] = encodeInf(val[k]);
    }
    return out;
  }

  return val;
};

// Formatowanie odpowiedzi do „ładnego stringa” w snapshotach
export const fmtAnswer = (val) => {
  if (val === null || typeof val === "undefined" || val === "") {
    return "";
  }
  if (typeof val === "string" || typeof val === "number" || typeof val === "boolean") {
    return String(val);
  }
  if (Array.isArray(val)) {
    return val.map((v) => fmtAnswer(v)).filter(Boolean).join(", ");
  }
  if (val && typeof val === "object") {
    for (const key of ["raw", "latex", "text", "expr"]) {
      if (key in val && val[key] != null && typeof val[key] !== "object") {
        return String(val[key]);
      }
    }
    if ("value" in val && val.value != null && typeof val.value !== "object") {
      return String(val.value);
    }
    const parts = Object.entries(val)
      .map(([key, value]) => {
        const text = fmtAnswer(value);
        return text ? `${key}: ${text}` : "";
      })
      .filter(Boolean);
    return parts.join(", ");
  }
  return String(val);
};

// Wykrywanie, czy użytkownik w ogóle coś wpisał (do display.hasAnswer)
export const detectHasAnswer = (ua) => {
  const visit = (value) => {
    if (value == null) return false;

    if (typeof value === "string") {
      return value.trim() !== "";
    }

    if (typeof value === "number" || typeof value === "boolean") {
      return true;
    }

    if (Array.isArray(value)) {
      return value.some((item) => visit(item));
    }

    if (typeof value === "object") {
      if ("choiceIndex" in value && typeof value.choiceIndex === "number") {
        return true;
      }
      if ("raw" in value) {
        return visit(value.raw);
      }
      if ("value" in value) {
        return visit(value.value);
      }

      return Object.entries(value).some(([key, nested]) => {
        if (["parsed", "parse", "error", "errors", "isValid", "valid"].includes(key)) {
          return false;
        }
        return visit(nested);
      });
    }

    return true;
  };

  return visit(ua);
};
